import { useNavigate, useSearch } from '@tanstack/react-router';

import { useRole } from '../../../common/hooks/useRole';
import { tabToOfferStateMap } from '../../../offer/OfferOverview/tabToOfferStateMap';
import { useRfqPaginationTotals } from '../hooks/useRfqPaginationTotals';

import { RfqTable } from './RfqTable';

export const SupplierRfqOverviewTable = () => {
    const role = useRole();
    const search = useSearch({ from: '/_app/offers' });
    const navigate = useNavigate({ from: '/offers' });

    const supplierIds =
        search.supplierIds && search.supplierIds.length > 0
            ? search.supplierIds
            : role.getCompanies().map((it) => it.id);

    const rfqPaginationTotals = useRfqPaginationTotals({
        searchQuery: search.searchQuery,
        supplierIds,
        customerIds: search.customerIds,
        tabToOfferStateMap: tabToOfferStateMap,
    });

    const onTabSelect = (tab: string) => {
        navigate({
            search: (previousSearch) => ({
                ...previousSearch,
                tab,
                page: 0,
            }),
        });
    };

    return (
        <RfqTable
            filters={{
                supplierIds,
                customerIds: search.customerIds,
                searchQuery: search.searchQuery,
                states: tabToOfferStateMap[search.tab],
                page: search.page,
                sortField: search.sortValue?.sortField,
                sortDirection: search.sortValue?.sortDirection,
            }}
            selectedTab={search.tab}
            rfqTotals={rfqPaginationTotals.data ?? {}}
            onTabSelect={onTabSelect}
            onPageChange={(page) => {
                navigate({
                    search: (previousSearch) => ({
                        ...previousSearch,
                        page,
                    }),
                });
            }}
        />
    );
};
